import { RouteConfig } from 'vue-router'

const profile: Array<RouteConfig> = [
  {
    path: ':id?/profile',
    component: () =>
      import(/* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfile.vue'),
    children: [
      {
        path: 'page_name',
        name: 'profile.page_name',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfilePageName.vue'
          ),
      },
    ],
  },
  {
    path: ':id/profile',
    component: () =>
      import(/* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfile.vue'),
    children: [
      {
        path: 'domain_name',
        name: 'profile.domain_name',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfileDomainName.vue'
          ),
      },
      {
        path: 'avatar',
        name: 'profile.avatar',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfileAvatar.vue'
          ),
      },
      {
        path: 'statistic',
        name: 'profile.statistic',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfileStatistic.vue'
          ),
      },
      {
        path: 'page_description',
        name: 'profile.page_description',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfilePageDescription.vue'
          ),
      },
      {
        path: 'page_cover',
        name: 'profile.page_cover',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfilePageCover.vue'
          ),
      },
      {
        path: 'followers',
        name: 'profile.followers',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfileFollowers.vue'
          ),
      },
      {
        path: 'content',
        name: 'profile.content',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfileContent.vue'
          ),
      },
      {
        path: 'create_post',
        name: 'profile.create_post',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfileCreatePost.vue'
          ),
      },
      {
        path: 'product_add',
        name: 'profile.product_add',
        component: () =>
          import(
            /* webpackChunkName: "builder" */ '@/views/builder/profile/BuilderProfileAddProduct.vue'
          ),
      },
    ],
  },
]

export default profile
